import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideEmbedDialog } from '../../../store/actions/embed';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import { getFontGoogleCodeName } from '../../../helpers/fonts';
import './Embed.css';
const ESCAPE_KEY = 27;

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideEmbedDialog: () => {
      dispatch(hideEmbedDialog());
    },
  }
}

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class Embed extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  handleKeyDown (event) {
    switch( event.keyCode ) {
      case ESCAPE_KEY:
        event.preventDefault();
        this.props.hideEmbedDialog();
        break;
      default:
        break;
    }
  }

  componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render () {
    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary
    } = fonts;

    const styles = {
      primaryFont: {
        fontFamily: primary.name
      },
      secondaryFont: {
        fontFamily: secondary.name
      }
    }

    const primaryCodeName = getFontGoogleCodeName(primary.name);
    const secondaryCodeName = getFontGoogleCodeName(secondary.name);

    return (
      <div className="embed-background">
        <div className="embed-wrapper">
          <div className="close-embed-container"
            onClick={this.props.hideEmbedDialog}>
            <NavigationClose className="close-embed-container-icon" />
          </div>
          <div className="embed-font-body">
            <div className="embed-primary-font">
              <a href={primary.googleUrl}
                target="_blank"
                className="embed-primary-font-header"
                style={styles.primaryFont}>
                {primary.name}
              </a>
              <div className="embed-font-designer">
                Designed by {primary.designer}
              </div>
              <a href={primary.googleUrl}
                target="_blank"
                className="google-link">View on Google Fonts</a>
            </div>
            <div className="embed-secondary-font">
              <a href={secondary.googleUrl}
                target="_blank"
                className="embed-secondary-font-header"
                style={styles.secondaryFont}>
                {secondary.name}
              </a>
              <div className="embed-font-designer">
                Designed by {secondary.designer}
              </div>
              <a href={secondary.googleUrl}
                target="_blank"
                className="google-link">View on Google Fonts</a>
            </div>
            <div className="embed-font-embed">
              To embed these fonts into a webpage, copy this code into the &lt;head&gt; of your HTML document.
            </div>
            <div className="embed-font-embed-container">
              &lt;link href=&quot;https://fonts.googleapis.com/css?family={primaryCodeName}|{secondaryCodeName}&quot; rel=&quot;stylesheet&quot;&gt;
            </div>
            <div className="embed-font-css">
              Then, use the following CSS rules to specify these families:
            </div>
            <div className="embed-font-embed-container">
              font-family: '{primary.name}';
              <br />
              font-family: '{secondary.name}';
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Embed = connect(mapStateToProps, mapDispatchToProps)(Embed);



// WEBPACK FOOTER //
// ./src/components/generator/embed/Embed.jsx